import React, { useEffect, useState } from "react";
import MyProfileDetails from "../MyProfileDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateUserDetails, getCurrentUser, getLoggedUserDetails,
  getPicUpdatedStatus,
  getUserProfilePic,
  getUserUpdateStatus, loadUserDetails,
  loadUserProfilePic,
  updateUserProfilePic,
  userDetailsUpdated,
  userProfilePicUpdated
} from "../../app/store/auth";
import { useNavigate } from "react-router-dom";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import { getAlert } from "../../services/appAlerts";
import { Modal } from "react-bootstrap";

const PartnerProfile = (props) => {
  const { profileShowHide, handleProfileShowHide } = props;


  const [profileEdit, setProfileEdit] = useState(false);
  const [showHide, setShowHide] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [profilePicObj, setProfilePicObj] = useState(null);
  const [profilePicData, setProfilePicData] = useState(null);

  const loggedUserDetailsSelector = useSelector(getLoggedUserDetails);
  const updateStatusSelector = useSelector(getUserUpdateStatus)
  const picUpdatedStatusSelector = useSelector(getPicUpdatedStatus);
  const userProfilePicSelector = useSelector(getUserProfilePic);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    dispatch(setCurrentPageTitle("My Profile"));
    dispatch(setCurrentRoute([]));
    dispatch(userProfilePicUpdated(true))
  }, [])

  useEffect(() => {
    if (currentUser?.id) {
      dispatch(loadUserDetails(currentUser.id));
    }
  }, []);

  useEffect(() => {
    if (loggedUserDetailsSelector)
      setUserDetails(loggedUserDetailsSelector);
  }, [loggedUserDetailsSelector])

  useEffect(() => {
    if (userProfilePicSelector) {
      //let objectURL = 'data:image/jpeg;base64,' + userProfilePicSelector;
      setProfilePicData(userProfilePicSelector);
    }
  }, [userProfilePicSelector])

  useEffect(() => {
    if (updateStatusSelector === "success" && currentUser?.id) {
      getAlert("", "Updated Successfully", "success");
      // dispatch(loadUserDetails(currentUser.id));
    } else if (updateStatusSelector === "fail") {
      getAlert("", "Update Failed", "error");
    }
    dispatch(loadUserDetails(currentUser.id));
    return () => {
      dispatch(userDetailsUpdated(null));
    }
  }, [updateStatusSelector])

  const handleModalShowHide = () => {
    setShowHide(!showHide);
  };

  const handleSubmit = async (profile) => {
    dispatch(UpdateUserDetails(profile));
    handleUpdatePic();
    dispatch(loadUserDetails(currentUser.id));
  };

  const handleUpdatePic = () => {
    const frmData = new FormData();
    frmData.append("userId", currentUser?.id);
    frmData.append("files[0]", profilePicObj?.file);
    dispatch(updateUserProfilePic(frmData));
  }

  useEffect(() => {
    if (picUpdatedStatusSelector) {
      dispatch(loadUserProfilePic(currentUser.id));
    }
  }, [picUpdatedStatusSelector])

  const handleImageChange = (e) => {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      setProfilePicObj({
        file: file,
        fileName: file.name,
        imagePreviewUrl: reader.result,
      })
    };

    reader.readAsDataURL(file);
  };

  const handleEditProfile = () => {
    setProfileEdit(!profileEdit);
  };

  let $imagePreview = null;
  if (profilePicObj) {
    $imagePreview = <img src={profilePicObj.imagePreviewUrl}
      alt="profile" className="img-thumbnail rounded-circle profilePrev" />
  } else {
    $imagePreview = <img
      alt="profile" className="img-thumbnail rounded-circle profilePrev"
      src={`${!profilePicData ? "../../assets/img/theme/team-4.png" : process?.env?.REACT_APP_API_BASEURL + "/ProfilePics/" + profilePicData}`}
    />
  }

  return (
    <React.Fragment>
      <Modal show={profileShowHide} size="xl">
        <Modal.Header closeButton onHide={handleProfileShowHide}>
          <Modal.Title>My Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body className="border pb-0">
          <div className="row">
            <div className="col-md-12 text-right">
              {!profileEdit &&
                <button
                  className="btn btn-sm btn-outline-default"
                  onClick={handleEditProfile}
                >
                  <i className="fa fa-edit" aria-hidden="true"></i> Edit
                </button>}
            </div>
            <div className="col-md-2 d-flex justify-content-center">
              {$imagePreview}
              <br />
              <div>
                <label className="profileBtn">
                  <input
                    type="file"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                    disabled={!profileEdit}
                  />
                  <i class="fa fa-camera" aria-hidden="true"></i>
                </label>
              </div>
            </div>
            <div className="col-md-10">
              <MyProfileDetails
                userDetails={userDetails}
                handleSubmit={handleSubmit}
                profileEdit={profileEdit}
                setProfileEdit={setProfileEdit}
                handleEditProfile={handleEditProfile}
              ></MyProfileDetails>
            </div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <button className="btn btn-sm btn-outline-default" onClick={handleProfileShowHide}>
            <i class="fa fa-times" aria-hidden="true"></i> Close
          </button>

        </Modal.Footer> */}
      </Modal>
    </React.Fragment>
  );
}

export default PartnerProfile;
